'use client';

import { forwardRef } from 'react';
import classnames from 'classnames/bind';
import { TIconProps } from '../_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'GlobeIcon';

export const GlobeIcon = forwardRef<SVGPathElement, TIconProps>(
  function GlobeIconFunction({ color }, ref) {
    return (
      <svg
        fill="none"
        height="17"
        width="17"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          ref={ref}
          className={cn(BLOCK_NAME, `${BLOCK_NAME}--${color}`)}
          clipRule="evenodd"
          d="M15.923 8.938a7.333 7.333 0 1 0-14.667 0 7.333 7.333 0 0 0 14.667 0M6.955 3.163a6.01 6.01 0 0 0-4.33 5.108h2.646c.09-1.827.545-3.176 1.103-4.195.187-.341.385-.644.58-.913m-4.33 6.442h2.646c.09 1.824.55 3.147 1.109 4.153.2.358.418.682.633.971a6.005 6.005 0 0 1-4.388-5.124m7.538 5.124a6.01 6.01 0 0 0 4.389-5.124h-2.647c-.09 1.824-.549 3.147-1.109 4.153-.199.358-.418.682-.633.971m4.389-6.458h-2.647c-.09-1.827-.545-3.176-1.103-4.195a8 8 0 0 0-.58-.913 6.01 6.01 0 0 1 4.33 5.108M7.546 13.11c-.452-.811-.85-1.916-.939-3.504h3.964c-.088 1.588-.487 2.693-.939 3.504-.35.629-.707 1.059-1.043 1.451-.336-.393-.693-.822-1.043-1.45m-.939-4.838h3.964c-.087-1.597-.485-2.729-.937-3.555a7.6 7.6 0 0 0-1.045-1.45 7.6 7.6 0 0 0-1.044 1.45c-.452.826-.85 1.958-.938 3.555"
          fill="#000"
          fillRule="evenodd"
        />
      </svg>
    );
  },
);
